// composables/useConfirmDiscard.ts
import { useConfirmModalStore } from '@/stores/confirmModal'
import { useErrorStore } from '@/stores/error'
import { getFieldMessage } from '@/utils/message'

export function useConfirmDiscard() {
  const confirmModal = useConfirmModalStore()
  const errorStore = useErrorStore()

  async function confirmDiscard(): Promise<boolean> {
    // エラー遷移中は常に許可
    if (errorStore.hasError) {
      return true
    }

    return await confirmModal.open({
      title: getFieldMessage('textdiscard001_1'),
      message: getFieldMessage('textdiscard001_2'),
      confirmText: '破棄する',
    })
  }

  return { confirmDiscard }
}
